import primary from './primary'
import secondary from './secondary'
import lightTheme from './lightTheme'
import darkTheme from './darkTheme'
import clientGetTheme from './clientGetTheme'

export { primary }
export { secondary }
export { lightTheme }
export { darkTheme }
export { clientGetTheme }

const themeService = {
  primary,
  secondary,
  lightTheme,
  darkTheme,
  clientGetTheme
}

export default themeService
